import { render, staticRenderFns } from "./exportFenxi1244.vue?vue&type=template&id=ea563c6c&scoped=true"
import script from "./exportFenxi1244.vue?vue&type=script&lang=js"
export * from "./exportFenxi1244.vue?vue&type=script&lang=js"
import style0 from "./exportFenxi1244.vue?vue&type=style&index=0&id=ea563c6c&prod&scoped=true&lang=css"
import style1 from "./exportFenxi1244.vue?vue&type=style&index=1&id=ea563c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea563c6c",
  null
  
)

export default component.exports